import { AgentEditorStore } from '../agent/store';

export class RootStore {
    agentEditorStore: AgentEditorStore;

    constructor() {
        this.agentEditorStore = new AgentEditorStore(this);
    }
}

export const rootStore = new RootStore();
